<template>
  <ul class="menu-tree">
    <li v-for="item in localItems" :key="item.id" class="menu-item">
      <div class="menu-header">
        <div class="menu-label" @click="toggleExpand(item)">
          <!-- Arrow icon for parents -->
          <span
            v-if="hasChildren(item)"
            class="arrow"
            :class="{ expanded: item.expanded }"
          >
            ▸
          </span>
          <i v-if="item.icon" :class="['menu-icon', item.icon]"></i>
          {{ item.label }}
        </div>

        <!-- Role checkboxes -->
        <div class="roles">
          <label
            v-for="role in allRoles"
            :key="role"
            class="role-checkbox"
          >
            <input
              type="checkbox"
              :value="role"
              v-model="item.requiredRoles"
              @change="emitRoleChange(item)"
            />
            {{ role }}
          </label>
        </div>
      </div>

      <!-- Recursive sub-items with transition -->
      <transition name="expand">
        <menu-item-tree
          v-if="hasChildren(item) && item.expanded"
          :items="item.subItems"
          :all-roles="allRoles"
          @update-roles="$emit('update-roles', $event)"
        />
      </transition>
    </li>
  </ul>
</template>

<script>
export default {
  name: "MenuItemTree",
  props: {
    items: { type: Array, required: true },
    allRoles: { type: Array, default: () => ["USER", "OFFICER", "ADMIN"] },
  },
  data() {
    return {
      localItems: [], // local copy with expand flags
    };
  },
  created() {
    // Deep copy so we can add "expanded" property safely
    this.localItems = this.items.map((item) => ({
      ...item,
      expanded: false,
    }));
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler(newItems) {
        this.localItems = newItems.map((item) => ({
          ...item,
          expanded: item.expanded || false,
        }));
      },
    },
  },
  methods: {
    toggleExpand(item) {
      if (this.hasChildren(item)) {
        item.expanded = !item.expanded;
      }
    },
    hasChildren(item) {
      return Array.isArray(item.subItems) && item.subItems.length > 0;
    },
    emitRoleChange(item) {
      this.$emit("update-roles", {
        id: item.id,
        requiredRoles: [...(item.requiredRoles || [])],
      });
    },
  },
};
</script>

<style scoped>
.menu-tree {
  list-style: none;
  padding-left: 1rem;
}

.menu-item {
  margin-bottom: 0.5rem;
}

.menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  padding: 6px 10px;
  border-radius: 4px;
  transition: background 0.2s;
}

.menu-header:hover {
  background: #e9f1ff;
}

.menu-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  user-select: none;
}

.menu-icon {
  margin-right: 5px;
  color: #666;
}

.arrow {
  display: inline-block;
  margin-right: 6px;
  font-size: 0.9rem;
  transition: transform 0.2s ease;
  color: #333;
}

.arrow.expanded {
  transform: rotate(90deg);
}

.roles {
  display: flex;
  gap: 8px;
}

.role-checkbox {
  font-size: 0.85rem;
}

/* Smooth expand/collapse transition */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.25s ease;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}
</style>
